import client from "./client";

const BASE = "/penalties";

export const penaltyTypes = async () => (await client.get(`${BASE}/types`)).data;
export const penaltyReasons = async () => (await client.get(`${BASE}/reasons`)).data;
export const disciplineStage = async (userId) =>
  (await client.get(`${BASE}/users/${userId}/discipline-stage`)).data;
export const employeeHistory = async (userId) => (await client.get(`${BASE}/employee/${userId}/history`)).data;
export const listPenalties = async (params = {}) => (await client.get(BASE, { params })).data;
export const getPenalty = async (id) => (await client.get(`${BASE}/${id}`)).data;
export const createPenalty = async (body) => (await client.post(BASE, body)).data;
export const approvePenalty = async (id) => (await client.put(`${BASE}/${id}/approve`)).data;
export const rejectPenalty = async (id, rejection_reason) =>
  (await client.put(`${BASE}/${id}/reject`, { rejection_reason })).data;
export const cancelPenalty = async (id) => (await client.put(`${BASE}/${id}/cancel`)).data;
export const deletePenalty = async (id) => (await client.delete(`${BASE}/${id}`)).data;
